module.exports = __webpack_public_path__ + "static/media/fiche_IPID_pvo+.a1123c41.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/go/documents/common/fiche_IPID_pvo+.pdf
// module id = 834
// module chunks = 40